import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { environment } from 'src/environments/environment';
import { formatDate } from '@angular/common';
import { Router, NavigationExtras, ActivatedRouteSnapshot } from '@angular/router';
import { Location } from '@angular/common';
import * as CryptoJS from 'crypto-js';
import { AppConstants } from '../app.constants';
import { DatePipe } from '@angular/common';
import * as paillierBigint from 'paillier-bigint';
import * as bigintUtils from 'bigint-crypto-utils'

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(@Inject(LOCALE_ID) private locale: string, private router: Router, private location: Location, private datePipe: DatePipe) { }

  validarObjeto(objeto): Boolean {
    if (objeto === undefined || objeto === null) {
      return false;
    } else {
      return true;
    }
  }

  getObjeto(objeto, defaultValue, isDate?, isHour?): any {
    isDate = this.validarObjeto(isDate) ? isDate : false;
    isHour = this.validarObjeto(isHour) ? isHour : false;
    if (this.validarObjeto(objeto)) {
      if (isDate)
        return this.fromISOJsonDate(objeto);
      else if (isHour)
        return this.formatDate(objeto, 'HH:mm:ss');
      else
        return objeto;
    } else {
      return defaultValue;
    }
  }

  getCombo(objeto, comboList, listIndex, defaultValue): any {
    if (this.validarObjeto(objeto) && this.validarObjeto(comboList) && comboList.length > 0) {
      return comboList[listIndex].find(e => e.id === objeto.id);
    } else {
      return defaultValue;
    }
  }

  getComboPorNombre(objeto, comboList, listIndex, defaultValue): any {
    if (this.validarObjeto(objeto) && this.validarObjeto(comboList) && comboList.length > 0) {
      return comboList[listIndex].find(e => e.nombre === objeto.toString());
    } else {
      return defaultValue;
    }
  }

  getComboVotacion(objeto, comboList, listIndex, defaultValue): any {
    if (this.validarObjeto(objeto) && this.validarObjeto(comboList) && comboList.length > 0) {
      return comboList[listIndex].find(e => e.idEstatusVotacion === objeto.idEstatusVotacion);
    } else {
      return defaultValue;
    }
  }

  getComboRoles(objeto, comboList, listIndex, defaultValue): any {
    if (this.validarObjeto(objeto) && this.validarObjeto(comboList) && comboList.length > 0) {
      return comboList[listIndex].find(e => e.id === objeto.idRolSistema);
    } else {
      return defaultValue;
    }
  }

  validarString(string): Boolean {
    if (string === '' || string === undefined || string === null || string === 'null') {
      return false;
    } else {
      return true;
    }
  }

  getString(string: string, withAppend?: boolean, appendValue?: string, withAppendOnReplace?: boolean, replaceValue?: string): string {
    withAppend = this.validarObjeto(withAppend) ? withAppend : false;
    withAppendOnReplace = this.validarObjeto(withAppendOnReplace) ? withAppendOnReplace : false;
    appendValue = this.validarString(appendValue) ? appendValue : '';
    replaceValue = this.validarString(replaceValue) ? replaceValue : '';
    let newString = '';
    if (this.validarString(string)) {
      if (withAppend) {
        newString = appendValue + string;
      } else {
        newString = string;
      }
    } else {
      if (withAppendOnReplace) {
        newString = appendValue + replaceValue;
      } else {
        newString = replaceValue;
      }
    }
    return newString;
  }

  setLocalStorage(clave, objeto, esJson): Boolean {
    if (esJson) {
      localStorage.setItem(clave, JSON.stringify(objeto));
    } else {
      localStorage.setItem(clave, objeto);
    }
    return true;
  }

  getLocalStorage(clave, esJson): any {
    let objeto = localStorage.getItem(clave);
    if (esJson && this.validarObjeto(objeto)) {
      return JSON.parse(objeto);
    } else {
      return objeto;
    }
  }

  removeLocalStorage(clave): Boolean {
    localStorage.removeItem(clave);
    return true;
  }

  reemplazar(texto: String, reemplazar, reemplazo) {
    return texto.replace(reemplazar, reemplazo);
  }

  redirectLogin() {
    localStorage.clear();
    this.redirectPath([AppConstants.APLICATION_MODULES.LOGIN.ruta], true);
  }

  redirectError() {
    this.redirectPath([AppConstants.APLICATION_MODULES.ERROR.ruta], true);
  }

  redirectPath(commands: any[], replaceState?: Boolean, extras?: NavigationExtras) {
    replaceState = this.validarObjeto(replaceState) ? replaceState : false;
    if (replaceState)
      this.location.replaceState('/');
    this.router.navigate(commands, extras);
  }

  redirectExternalPath(ruta: string) {
    window.location.href = ruta;
  }

  redirectPathWindow(ruta: string, appendRoot?: boolean) {
    appendRoot = this.validarObjeto(appendRoot) ? appendRoot : true;
    let url = '';
    if (appendRoot)
      url = window.location.origin.replace('@PROTOCOLO', environment.ENVIRONMENT.PROTOCOLO) + '/' + ruta;
    else
      url = window.location.origin.replace('@PROTOCOLO', environment.ENVIRONMENT.PROTOCOLO) + ruta;
    window.location.href = url;
  }

  getBooleanFromNumber(numero: number) {
    return numero === 1 ? true : false;
  }

  getNumberFromBoolean(boleano: boolean) {
    return boleano ? 1 : 0;
  }

  fromISOJsonDate(jDate): string {
    const bDate: Date = new Date(jDate);
    return bDate.toISOString().substring(0, 10);  //Ignore time
  }

  toDateFormat(date, format) {
    let dateFormatValue = formatDate(date, format, this.locale);
    return dateFormatValue;
  }

  formatDate(date: Date, format: string) {
    return this.datePipe.transform(date, format);
  }

  /**
     * Esta funcion se utilizara para inicializar una tabla con paginado
     * @returns tabla
     */
  inicializarTablaPaginado() {
    let tabla = {
      datos: [],
      paginaDefault: 0,
      tamanioPagina: 10,
      paginaInicial: 0,
      paginaFinal: 0,
      totalRegistros: 0,
      ocultarPaginado: true,
      links: {
        linkSiguiente: '',
        linkAnterior: '',
        linkPrimero: '',
        linkUltimo: ''
      },
      pagination: {
        disabledSiguiente: true,
        disabledAnterior: true,
        disabledPrimero: true,
        disabledUltimo: true
      },
      hrefComplemento: ''
    };

    return tabla;
  }

  /**
   * Esta funcion se utilizara para los generar los links del paginado
   * el paginado viene del backend de Java. Si se implementa otra forma de paginar
   * se tendra que crear un nuevo método
   * @param {*} datos Datos de la paginación devuelta por el backend de Java
   * @param {*} links Objeto links de la tabla a procesar
   * @param {*} href Complemento de url que se va agregar a cada link del paginado
   * @param {*} pagination Objeto pagination de la tabla a procesar
   * @param {*} conReemplazo Indica si se va a reemplazar la url de cada link del paginado
   * @param {*} urlReemplazar Url que se va a reemplazar
   * @param {*} urlReemplazo Url que se va a incrustar
   * @returns links
   */
  obtenerLinks(datos, links, href, pagination, conReemplazo, urlReemplazar, urlReemplazo) {
    datos.map((items) => {
      var linkUrl = items.href + href;

      if (conReemplazo) {
        linkUrl = this.reemplazarLink(linkUrl, urlReemplazar, urlReemplazo);
      }

      if (items.rel == 'next') {
        links.linkSiguiente = linkUrl;
        pagination.disabledSiguiente = false;
      } else if (items.rel == 'prev') {
        links.linkAnterior = linkUrl;
        pagination.disabledAnterior = false;
      } else if (items.rel == 'first') {
        links.linkPrimero = linkUrl;
        pagination.disabledPrimero = false;
      } else if (items.rel == 'last') {
        links.linkUltimo = linkUrl;
        pagination.disabledUltimo = false;
      }
    });
  }

  agregarLinksSpringBoot(linksData) {
    let links = [];
    if (this.validarObjeto(linksData.next))
      links.push({ rel: 'next', href: linksData.next.href });
    if (this.validarObjeto(linksData.prev))
      links.push({ rel: 'prev', href: linksData.prev.href });
    if (this.validarObjeto(linksData.first))
      links.push({ rel: 'first', href: linksData.first.href });
    if (this.validarObjeto(linksData.last))
      links.push({ rel: 'last', href: linksData.last.href });
    return links;
  }

  /**
   * Esta funcion se utilizara para reemplazar las urls de los links del paginado
   * @param {*} link Link con los datos a reemplazar
   * @param {*} urlReemplazar Url a reemplazar
   * @param {*} urlReemplazo Url nueva después del reemplazo
   * @returns link
   */
  reemplazarLink(link, urlReemplazar, urlReemplazo) {
    let newLink = link;
    if (this.validarString(link)) {
      newLink = this.reemplazar(link, urlReemplazar, urlReemplazo);
    }
    return newLink;
  }

  /**
   * Procesa la paginacion de una tabla
   * @param {*} tabla Tabla que se va a procesar
   * @param {*} data Datos de la promesa que contiene la acción que devuelve un objeto de paginación
   * @param {*} conReemplazo Indica si se va a reemplazar la url de cada link del paginado
   * @param {*} urlReemplazar Url que se va a reemplazar
   * @param {*} urlReemplazo Url que se va a incrustar
   * @param {*} springBoot Indica si el paginado es de un backend de springboot
   */
  procesarPaginado(tabla, data, conReemplazo, urlReemplazar, urlReemplazo, springBoot) {
    springBoot = this.validarObjeto(springBoot) ? springBoot : true;
    tabla.datos = data.content;
    tabla.paginaInicial = (data.number + 1);
    tabla.paginaFinal = data.totalPages;
    tabla.totalRegistros = data.totalElements;

    if (tabla.paginaFinal > 1) {
      tabla.ocultarPaginado = false;

      tabla.links = {
        linkSiguiente: '',
        linkAnterior: '',
        linkPrimero: '',
        linkUltimo: ''
      };

      tabla.pagination = {
        disabledSiguiente: true,
        disabledAnterior: true,
        disabledPrimero: true,
        disabledUltimo: true
      };

      if (springBoot) {
        data.links = [];
        data.links = this.agregarLinksSpringBoot(data._links);
      }

      this.obtenerLinks(data.links, tabla.links, tabla.hrefComplemento, tabla.pagination, conReemplazo, urlReemplazar, urlReemplazo);
    } else {
      tabla.ocultarPaginado = true;
    }

    return tabla;
  }

  codificar(datos: any, esJson?: Boolean): string {
    esJson = this.validarObjeto(esJson) ? esJson : false;
    let salt = environment.ENVIRONMENT.SALT;
    let datosString = esJson ? JSON.stringify(datos) : datos;
    let hash = CryptoJS.AES.encrypt(datosString, salt.trim()).toString();
    return hash;
  }

  decodificar(hashDatos: string, esJson?: Boolean): any {
    esJson = this.validarObjeto(esJson) ? esJson : false;
    let salt = environment.ENVIRONMENT.SALT;
    let datosString = CryptoJS.AES.decrypt(hashDatos, salt).toString(CryptoJS.enc.Utf8);
    let datos = esJson ? JSON.parse(datosString) : datosString;
    return datos;
  }

  codificarSHA512(datos: any, esJson?: Boolean): string {
    esJson = this.validarObjeto(esJson) ? esJson : false;
    let datosString = esJson ? JSON.stringify(datos) : datos;
    let hash = CryptoJS.SHA512(datosString).toString(CryptoJS.enc.Hex);
    return hash;
  }

  codificarSHA256(datos: any, esJson?: Boolean): string {
    esJson = this.validarObjeto(esJson) ? esJson : false;
    let datosString = esJson ? JSON.stringify(datos) : datos;
    let hash = CryptoJS.SHA256(datosString).toString(CryptoJS.enc.Hex);
    return hash;
  }

  obtenerLlavePublicaPaillier(llavePublica: string) {
    try {
      let n = BigInt(llavePublica);
      let g = n + 1n;
      let publicKey = new paillierBigint.PublicKey(n, g);
      return publicKey;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  obtenerLlavePrivadaPaillier(llavePublica: paillierBigint.PublicKey, llavePrivada: string) {
    try {
      let lambda: bigint, mu: bigint;
      lambda = BigInt(llavePrivada);
      mu = bigintUtils.modInv(lambda, llavePublica.n);
      let privateKey = new paillierBigint.PrivateKey(lambda, mu, llavePublica);
      return privateKey;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  verificarLLavesPaillier(llavePublica: paillierBigint.PublicKey, llavePrivada: paillierBigint.PrivateKey) {
    if (this.validarObjeto(llavePublica) && this.validarObjeto(llavePrivada)) {
      let datoTest = 1n;
      let datoCifradoTest = llavePublica.encrypt(datoTest);
      let datoDescifradoTest = llavePrivada.decrypt(datoCifradoTest);
      return datoTest.toString() === datoDescifradoTest.toString();
    } else
      return false;
  }

  cifrarPaillier(datos: string, llavePublica: paillierBigint.PublicKey) {
    try {
      let m = BigInt(datos);
      let datosCifrados = llavePublica.encrypt(m).toString();
      return datosCifrados;
    } catch (error) {
      console.error(error);
      return '';
    }
  }

  descifrarPaillier(datosCifrados: string, llavePrivada: paillierBigint.PrivateKey) {
    try {
      let c = BigInt(datosCifrados);
      let datos = llavePrivada.decrypt(c).toString();
      return datos;
    } catch (error) {
      console.error(error);
      return '';
    }
  }

  multiplicarPaillier(datoCifrado1: string, datoCifrado2: string, llavePublica: paillierBigint.PublicKey) {
    try {
      let c1 = BigInt(datoCifrado1);
      let c2 = BigInt(datoCifrado2);
      let r = llavePublica.multiply(c1, c2);
      return r.toString();
    } catch (error) {
      console.error(error);
      return '';
    }
  }

  sumarPaillier(datoCifrado1: string, datoCifrado2: string, llavePublica: paillierBigint.PublicKey) {
    try {
      let c1 = BigInt(datoCifrado1);
      let c2 = BigInt(datoCifrado2);
      let r = llavePublica.addition(c1, c2);
      return r.toString();
    } catch (error) {
      console.error(error);
      return '';
    }
  }

  clonarObjeto(objeto: any) {
    return Object.assign({}, objeto);
  }

  clonarLista(objeto: any[]) {
    return Object.assign([], objeto);
  }

  concatenarFechaHora(date: string, hour: string) {
    return date + 'T' + hour;
  }

  invertirTexto(texto: string) {
    return texto.split("").reverse().join("");
  }

  // contarZeros(textoNumero: string) {
  //   let a = Number(textoNumero), b, count = 0
  //   while (a > 0) {
  //     b = a % 10;
  //     if (b == 0) {
  //       count++;
  //     }
  //     a = parseInt(a / 10);
  //   }
  //   return count;
  // }

  contarZeros(textoNumero: string) {
    var sum = 0;
    for (var i = 0, length = textoNumero.length; i < length; i++) {
      sum += Number(textoNumero[i]);
    }
    return textoNumero.length - sum;
  }

  descomponerValorMod10(textoNumero: string, maximoFactorIteracion: Number) {
    let datosDescomposicion = [];
    let factor = 1;
    let codificacion = 1;
    let iteracion = 1;
    let resultadoFactor = 0;
    let resultadoCodificacion = 0;
    for (var i = 0; i < textoNumero.length; i++) {
      let valor = Number(textoNumero.charAt(i));
      resultadoFactor = valor * factor;
      resultadoCodificacion = valor * codificacion;
      datosDescomposicion.push({
        digito: valor,
        base: codificacion,
        resultadoBase: resultadoCodificacion,
        resultadoFinal: resultadoFactor
      });
      codificacion = codificacion * 10;
      if (iteracion < maximoFactorIteracion) {
        factor = factor * 10;
        iteracion++;
      } else {
        factor = 1;
        iteracion = 1;
      }
    }
    return datosDescomposicion;
  }

  permitirAcceso(modulo: any): Boolean {
    let sesion = this.getLocalStorage('sesion', true);
    let sesionDecodificada = this.validarObjeto(sesion) ? this.decodificar(sesion, true) : null;
    if (this.validarObjeto(sesionDecodificada)) {
      let rol = sesionDecodificada.rol;
      let permitir = modulo.roles.includes(rol);
      return permitir;
    } else {
      return false;
    }
  }

  obtenerDatosUsuario(): any {
    let sesion = this.getLocalStorage('sesion', true);
    let sesionDecodificada = this.validarObjeto(sesion) ? this.decodificar(sesion, true) : null;
    if (this.validarObjeto(sesionDecodificada)) {
      let datosUsuario = { usuario: sesionDecodificada.usuario, rol: sesionDecodificada.rol };
      return datosUsuario;
    } else {
      return null;
    }
  }

}
